var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCadastrarUnidade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3543 4.76863C10.5494 4.96371 10.5494 5.28084 10.3543 5.47593C10.1593 5.67101 9.84213 5.67101 9.64705 5.47593C9.45197 5.28084 9.45197 4.96371 9.64705 4.76863C9.84213 4.57355 10.1583 4.57355 10.3543 4.76863",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.312 5.22485V5.22485C14.312 6.39634 13.7918 7.5058 12.8925 8.25612L11.4789 9.43461C10.9156 9.9048 10.4945 10.5221 10.2624 11.2184L10.0002 12.0007L9.73914 11.2174C9.50704 10.5221 9.08587 9.9038 8.52263 9.43361L7.10905 8.25512C6.20867 7.5048 5.68945 6.39534 5.68945 5.22385V5.22385V5.24586C5.68845 2.55674 7.91638 0.996094 10.0002 0.996094C12.0841 0.996094 14.312 2.55674 14.312 5.24686",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99872 10C3.04532 10 2.22398 10.6733 2.0369 11.6087L1.03649 16.6108C0.788384 17.8483 1.73578 19.0037 2.9983 19.0037H17.0031C18.2657 19.0037 19.2131 17.8483 18.965 16.6108L17.9645 11.6087C17.7775 10.6733 16.9561 10 16.0027 10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastrarUnidade);
export default __webpack_public_path__ + "static/media/cadastrarUnidade.cee71662045699ec71e26f7b05bb0b54.svg";
export { ForwardRef as ReactComponent };